import axiosInstance from "./Utils/axiosInstance";

export class TimesheetSecurity {
  static async getTimesheetSecurityData(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-data-service/1.0/timesheetSecurity",
        payload
      );
      return data.securityList[0];
    } catch (error) {
      throw error;
    }
  }
}
